import { useState, useEffect, useMemo } from 'react';
import Papa from 'papaparse';

let cachedData = null;
let isLoading = false;

export const useCsvData = (searchArray) => {
  const [data, setData] = useState(cachedData);
  const [loading, setLoading] = useState(isLoading);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    if (cachedData || isLoading) return;

    const loadCsv = async () => {
      isLoading = true;
      setLoading(true);
      
      try {
        const path = '/utils/mocks/csv/arquivo.csv';
        const response = await fetch(path); 
        const csvText = await response.text();

        Papa.parse(csvText, {
            header: false,
            skipEmptyLines: true,
            complete: (results) => {
                const formattedData = results.data.map((row, index) => ({
                    id: index + 1, 
                    name: String(row[1] ?? ""),
                    description: String(row[2] ?? ""),
                    required_materials: String(row[6] ?? ""),
                    instruction: String(row[5] ?? ""),
                    ability: String(row[0] ?? ""), 
                    ability_score: Number(row[3]) || 0,
                    subscore: Number(row[4]) || 0,
                    participants_quantity: String(row[7]) || "",
                    space_size: String(row[8] ?? ""),
                    space_type: String(row[9] ?? ""),
                    space_quantity: String(row[10]) || "",
                    category: String(row[11] ?? "")
                }));

                cachedData = formattedData;
                setData(cachedData);
                isLoading = false;
                setLoading(false);
            },
            error: (err) => {
                console.error("PapaParse conversion error:", err);
                isLoading = false;
                setLoading(false);
            }
        });

      } catch (error) {
        console.error("Error fetching CSV:", error);
        setError(error.message);
        isLoading = false;
        setLoading(false);
      }
    };

    loadCsv();
  }, []);

  const filteredData = useMemo(() => {
    if(!searchArray) return;

    if (!data || data.length === 0 || !Array.isArray(searchArray)) {
      return data || [];
    }

    const [communicativeScore, socialScore, motorScore] = searchArray;

    return data.filter((item) => {
      const ability = (item.ability || '').toLowerCase().trim();
      const itemScore = Number(item.ability_score);
      
      if (ability === 'comunicativa') {
        return communicativeScore !== 0 && itemScore === Number(communicativeScore);
      }

      if (ability === 'social') {
        return socialScore !== 0 && itemScore === Number(socialScore);
      }

      if (ability === 'motora') {
        return motorScore !== 0 && itemScore === Number(motorScore);
      }

      return false;
    });
  }, [data, JSON.stringify(searchArray)]); 

  return { data, loading, filter: filteredData, error };
};